import type { NavigateOptions } from 'react-router-dom';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const usePartitionTagsPageRedirect = (codeFromParams?: string) => {
  const { code } = useModuleByCodeParam();

  const { doRedirectWithSavePageUrl, doRedirectOnPrevPage, ...methods } = usePagesRedirect(
    'usePartitionTagsPageRedirect'
  );

  const goToTagsPage = ({
    partitionId,
    navState,
  }: {
    partitionId: number;
    navState?: NavigateOptions;
  }) => {
    doRedirectWithSavePageUrl(
      `/common/${codeFromParams ?? code}/partitions/${partitionId}`,
      navState
    );
  };

  return {
    ...methods,
    goBack: (navState?: NavigateOptions) => doRedirectOnPrevPage('/', navState),
    goToTagsPage,
  };
};
